<div class="status-msg-container" *ngIf="requestFailed()">
    <div class="status">
        <div class="msg-row">
            <div class="icon">
                <mat-icon class="sub--icon error-color">highlight_off</mat-icon>
            </div>
            <div class="msg-title">
                ERROR <br />
                {{ errorMessage }}
            </div>
        </div>
        <p class="error" *ngIf="errorDescription">{{ errorDescription }}</p>
    </div>
</div>
<div class="status-msg-container" *ngIf="!requestFailed()">
    <div class="status">
        <div class="msg-row">
            <div class="icon">
                <mat-icon class="sub--icon success-color">check_circle_outline</mat-icon>
            </div>
            <div class="msg-title">{{ successMessage }}</div>
        </div>
        <p class="success">You can now close the wizard</p>
    </div>
</div>